import React, { useContext } from 'react';

export const createMainClockContext = () => React.createContext<Date | undefined>(undefined);

export const MainClockContext = createMainClockContext();

export const useMainClockContext: () => Date = () => {
  const context = useContext(MainClockContext);
  if (!context) {
      throw new Error("useMainClockContext must be used within an MainClockContext");
  }
  return context;
};